import { Dispatch, FC, SetStateAction } from "react";
import { useIntl } from "../../../../../../_metronic/i18n/customUseIntl";
import { CSSClassesList } from "../../../../helpers/helperTypes";
import { UserProfilePrefs } from "../../../../../modules/Helpers/UserProfilePrefs";
import { processAndStageStylesV2 } from "../../../../../../_metronic/layout";
import { useFormContext } from "react-hook-form";
import { BeefIntervention } from "../../../../models/Intervention/BeefIntervention";
import { DsmGrid } from "@dsm-dcs/design-system-react";
import ReactHookDsmInput from "../../../../../modules/Helpers/ReactHookDsmInput2";
import { unitLong } from "../../../../utils/unit-utils";
import { Spacer } from "../../../helpers/Spacer";
import RowTextFieldWithMetrics from "../../../../../modules/Farms/Intervention/RowControlledTextFieldWithMetrics2";
import { FormType } from "../../common";
import { BeefInputBreeding } from "../../../../models/Baseline/BeefBaseline";
import EditModeButtons from "../../../helpers/EditModeButtons";
import { isFieldFilled } from "../CommonDataParts/InterventionGenericInfoDialog";

interface BeefInputBreedingNewAnimalsComponentProps {
  formType: FormType;
  fieldItemPrefix: string;
  defaultStageData: BeefInputBreeding;
  isNewAnimalsEdit: boolean;
  setIsNewAnimalsEdit: Dispatch<SetStateAction<boolean>>;
  newAnimalsCancelHandler: (isInnerCancel?: boolean) => void;
}

const BeefInputBreedingNewAnimalsComponent: FC<BeefInputBreedingNewAnimalsComponentProps> = ({
  formType,
  fieldItemPrefix,
  defaultStageData,
  isNewAnimalsEdit,
  setIsNewAnimalsEdit,
  newAnimalsCancelHandler,
}) => {
  const intl = useIntl();
  const classes: CSSClassesList = processAndStageStylesV2();
  const userUOM = UserProfilePrefs.getInstance().getUserUnitPrefs();
  const fc = useFormContext<BeefIntervention>();

  return (
    <>
      <p className={classes.headingTitleVariant}>
        {intl.formatMessage({ id: "SUSTELL.STAGE.CATTLE.INPUT.NEW_ANIMALS" })}
      </p>
      <p>
        {intl.formatMessage({ id: "SUSTELL.STAGE.CATTLE.INPUT.NEW_ANIMALS_DESCRIPTION" })}
      </p>
      <DsmGrid className={classes.dsmGridTwoColumnNoRowSpacing}>
        {!isNewAnimalsEdit ? (
          <>
            {isFieldFilled(fc.getValues(`${fieldItemPrefix}.averageWeightNewAnimals`)) ? (
              <div>
                <RowTextFieldWithMetrics
                  name={`${fieldItemPrefix}.averageWeightNewAnimals`}
                  label={intl.formatMessage({ id: "SUSTELL.STAGE.BEEF.INPUT.AVERAGE_WEIGHT_NEW_ANIMALS" })}
                  tooltip={intl.formatMessage({ id: "SUSTELL.STAGE.BEEF.INPUT.AVERAGE_WEIGHT_NEW_ANIMALS.TOOLTIP" })}
                  baseline={defaultStageData.averageWeightNewAnimals}
                  displayTypeSelect={false}
                  type="number"
                  metricUnit={intl.formatMessage(
                    { id: "SUSTELL.STAGE.BEEF.INPUT.AVERAGE_WEIGHT_NEW_ANIMALS.ADORNMENT" },
                    { unit: userUOM?.unitOutputMass ? unitLong(userUOM.unitOutputMass) : "kg" }
                  )}
                  disabled
                />
                <Spacer />
              </div>
            ) : (
              <ReactHookDsmInput
                name={`${fieldItemPrefix}.originalAverageWeightNewAnimals`}
                label={intl.formatMessage({ id: "SUSTELL.STAGE.BEEF.INPUT.AVERAGE_WEIGHT_NEW_ANIMALS" })}
                tooltip={intl.formatMessage({ id: "SUSTELL.STAGE.BEEF.INPUT.AVERAGE_WEIGHT_NEW_ANIMALS.TOOLTIP" })}
                adornment={intl.formatMessage(
                  { id: "SUSTELL.STAGE.BEEF.INPUT.AVERAGE_WEIGHT_NEW_ANIMALS.ADORNMENT" },
                  { unit: userUOM?.unitOutputMass ? unitLong(userUOM.unitOutputMass) : "kg" }
                )}
                defaultValue={defaultStageData.averageWeightNewAnimals}
                type="number"
                disabled
              />
            )}
          </>
        ) : (
          <div>
            <RowTextFieldWithMetrics
              name={`${fieldItemPrefix}.averageWeightNewAnimals`}
              label={intl.formatMessage({ id: "SUSTELL.STAGE.BEEF.INPUT.AVERAGE_WEIGHT_NEW_ANIMALS" })}
              tooltip={intl.formatMessage({ id: "SUSTELL.STAGE.BEEF.INPUT.AVERAGE_WEIGHT_NEW_ANIMALS.TOOLTIP" })}
              baseline={defaultStageData.averageWeightNewAnimals}
              type="number"
              metricUnit={intl.formatMessage(
                { id: "SUSTELL.STAGE.BEEF.INPUT.AVERAGE_WEIGHT_NEW_ANIMALS.ADORNMENT" },
                { unit: userUOM?.unitOutputMass ? unitLong(userUOM.unitOutputMass) : "kg" }
              )}
              disabled={false}
            />
            <Spacer />
          </div>
        )}
        <div />
        {formType !== FormType.View &&
          <EditModeButtons
            isEditing={isNewAnimalsEdit}
            onEdit={() => setIsNewAnimalsEdit(true)}
            onCancel={newAnimalsCancelHandler}
          />}
      </DsmGrid>
    </>
  )
}

export default BeefInputBreedingNewAnimalsComponent;
